import Image_Default from "../../images/man.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {connect} from "react-redux";
import { setDialogTweetShow } from "../../redux/actions/actions.js";
import axios from "axios";

const Dialog_CreateTweet = (props) => {
    const [content,setContent] = useState("");
    const navigate = useNavigate();
    const {user,color_background,color_button,dialog_tweet_show,onSetDialogTweetShow} = props;

    const postTweet = async() => {
        try {
            const response = await axios.post("/newpost",{
                content:content,
                user_id:user.id
            },{
                withCredentials:true,
                headers:{
                    "Content-Type":"application/json"
                }
            });
            console.log("success");
            let input = document.getElementsByName("dialog_create_tweet_text")[0];
            input.value = "";
            setContent("");
            onSetDialogTweetShow("hide");
            navigate("/");
        } catch (error) {
            console.log(error);
        }
    }
    const closeDialog = () => {
        onSetDialogTweetShow("hide");
        let input = document.getElementsByName("dialog_create_tweet_text")[0];
        input.value = "";
        setContent("");
    }
    const closeOutside = (e) => {
        const isOutside = !e.target.closest('.dialog_create_tweet');
        if (isOutside) {
            closeDialog();
        }
    }
    return(
        <div onClick={closeOutside} className={`dialog_window dialog_window_${color_background} dialog_window_${dialog_tweet_show}`}>
            <div className={`dialog_create_tweet dialog_${color_background}`}>
                <div className="button_close_div">
                    <div onClick={closeDialog} className={`button_more_div background_change_hover_${color_background}`}>
                        <i className="fa-solid fa-xmark"></i>
                    </div>
                </div>
                <div className="create_tweet_div">
                    <img src={Image_Default} alt="User" className="user_image user_image_tweet" />
                    <div className="dialog_create_tweet_text_div">
                        <textarea onChange={(e) => setContent(e.target.value)} className={`dialog_create_tweet_text profile_edit_form_input_color background_change_${color_background}`} rows="5" name="dialog_create_tweet_text" placeholder="What's happening?" required></textarea>
                        <div className={`main_content_section main_content_section_${color_background} create_tweet_text_hr`}></div>
                    </div>
                </div>
                <div className="create_tweet_button_div">
                    {
                        content.trim() ? 
                        <button onClick={postTweet} className={`create_tweet_button customizecolorchange_hover customizecolorchange_${color_button}`}>Tweet</button> :
                        <button onClick={postTweet} className={`create_tweet_button_disabled customizecolorchange_disabled_${color_button}`} disabled={true}>Tweet</button>
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button,
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user,
        dialog_tweet_show: state.setDialogTweetShow.dialog_tweet_show
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onSetDialogTweetShow: (text) => dispatch(setDialogTweetShow(text))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Dialog_CreateTweet);